import React, { Dispatch, SetStateAction } from 'react';

import classnames from 'classnames/bind';
import styles from './AccountCustomerAddress.module.scss';
import { AccountInfoCard, AddressForm, Button } from '@components';
import { Address } from '@commercetools/platform-sdk';
import { useForm } from 'hooks';
import { getFormFields } from 'components/CustomerInfoForm';
import { Modal, Typography } from 'gd-design-library';

const CN = 'account-customer-address';
const saveButtonClassName = `${CN}__save-button`;

const cx = classnames.bind(styles);

interface AccountCustomerNameProps {
  address: Partial<Address> | null;
  modalOpened: boolean;
  setModalOpened: Dispatch<SetStateAction<boolean>>;
  handleSave: (address: Partial<Address>) => Promise<void>;
  isSaveLoading: boolean;
}

export const AccountCustomerAddress: React.FC<AccountCustomerNameProps> = ({
  address,
  modalOpened,
  setModalOpened,
  handleSave,
  isSaveLoading
}) => {
  const {
    firstName = '',
    lastName = '',
    streetName = '',
    building = '',
    state = '',
    city = '',
    postalCode = '',
    phone = ''
  } = address ?? {};
  const openModal = (): void => setModalOpened(true);
  const closeModal = (): void => setModalOpened(false);

  const formFields = getFormFields(address);
  const formData = useForm(formFields);

  return address && <div className={ cx(CN) }>
    <AccountInfoCard onEdit={ openModal } title='Saved Address'>
      <Typography> { `${firstName} ${lastName}` } </Typography>
      <Typography> { `${streetName} ${building}` } </Typography>
      <Typography> { `${state} ${city} ${postalCode}` } </Typography>
      <Typography> { phone } </Typography>
    </AccountInfoCard>
    <Modal isOpen={ modalOpened } onClose={ closeModal } title='Edit Address'>
      <AddressForm formData={ formData }/>
      <Button
        loading={ isSaveLoading }
        className={ cx(saveButtonClassName) }
        onClick={ (): Promise<void> => handleSave(formData.state) }
        disabled={ !formData.isValid }
      >
          Save
      </Button>
    </Modal>
  </div>;
};
